import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ShortReport from "./ShortReport";
import VideoReport from "./VideoReport";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import { getReportStatsData } from "../../store/report/report.action";
import StatsCards from "../../extra/StatsCards";
import { IconReport, IconVideo, IconMovie } from "@tabler/icons-react";

export default function ManageReport() {
  const dispatch = useDispatch();
  const { multiButtonSelect, setMultiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch("Shorts Report");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { reportStatsData } = useSelector((state) => state.report);

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getReportStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [
    {
      title: "Total Reports",
      count: reportStatsData?.totalReports,
      Icon: IconReport,
    },
    {
      title: "Total Video Reports",
      count: reportStatsData?.totalVideoReports,
      Icon: IconVideo,
    },
    {
      title: "Total Short Reports",
      count: reportStatsData?.totalShortReports,
      Icon: IconMovie,
    },
  ];

  return (
    <div className="userPage channelPage">
      <div>
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            setMultiButtonSelect={handleMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            labelData={["Shorts Report", "Video Report"]}
          />
        </div>
        <StatsCards cards={statsCards} colClass="col-xl-4 col-sm-6 col-12" />
        {multiButtonSelect == "Shorts Report" && (
          <ShortReport endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Video Report" && (
          <VideoReport
            endDate={endDateData}
            startDate={startDateData}
            setMultiButtonSelect={setMultiButtonSelect}
          />
        )}
      </div>
    </div>
  );
}
